module.exports = __webpack_public_path__ + "static/media/img4.3bcf9ab2.jpg";